import _ from 'lodash';
import {
  SET_ORDERS_PAST,
  SET_ORDERS_CANCELED,
  SET_ORDERS,
  RESET_ORDERS,
  REFUND_ORDER,
  SET_FINISH_ORDERS
} from '../actions/types/index';

const INITIAL_STATE = {
  pastOrder: null,
  cancelOrder: null,
  orders: null,
  finishedOrders: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ORDERS: {
      return { ...state, orders: action.payload };
    }
    case SET_ORDERS_PAST: {
      return { ...state, pastOrder: action.payload };
    }
    case SET_ORDERS_CANCELED: {
      return { ...state, cancelOrder: action.payload };
    }
    case SET_FINISH_ORDERS: {
      return { ...state, finishedOrders: action.payload };
    }
    case REFUND_ORDER: {
      const ordersWithoutOne = _.filter(
        state.finishedOrders,
        elt => elt.chargeId !== action.payload.chargeId
      );
      return {
        ...state,
        finishedOrders: [...ordersWithoutOne, action.payload]
      };
    }
    case RESET_ORDERS: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
};
